<template>
	<div id="app">
		<nav-bar @logout="onLogoutClick"/>
		<aside-menu
			:menu="menu"
			:menu-bottom="menuBottom"
			@menu-click="menuClick"
			:class="{'has-secondary':!!menuSecondary}" />
		<aside-menu
			v-if="menuSecondary"
			:menu="menuSecondary"
			:is-secondary="true"
			:label="menuSecondaryLabel"
			:icon="menuSecondaryIcon"
			@menu-click="menuClick"
			@close="menuSecondaryCloseClick"/>
		<router-view/>
		<aside-right/>
		<footer-bar/>
		<overlay/>
	</div>
</template>

<style lang="scss">
$spaces: (0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50); // 0から50pxまでを用意
$sides: (top, bottom, left, right); // 方向性
@each $space in $spaces {
	@each $side in $sides {
		.m#{str-slice($side, 0, 1)}-#{$space} {
			margin-#{$side}: #{$space}px !important;
		}

		.p#{str-slice($side, 0, 1)}-#{$space} {
			padding-#{$side}: #{$space}px !important;
		}
	}
}

section.section.is-title-bar {
	padding: .8rem;
}

.button {
	width: 120px;
}

label.require:after {
	content: ' *';
	color: red;
}

.field-label {
	margin-bottom: 20px;
}

table button.is-small {
	width: 50px;
}

.horizontal-center {
	display: flex;
	align-items: center;
}

.list-color-sample {
	width: 50px;
	height: 20px;
}

.menu-list ul li {
	padding-left: 36px;
}

.field.is-grouped {
	align-items: center;
}

</style>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import NavBar from '@/components/NavBar'
import AsideMenu from '@/components/AsideMenu'
import FooterBar from '@/components/FooterBar'
import Overlay from './components/Overlay'
import AsideRight from '@/components/AsideRight'

export default {
	name: 'App',
	components: {
		AsideRight,
		Overlay,
		FooterBar,
		AsideMenu,
		NavBar
	},
	data () {
		return {
			menuSecondary: null,
			menuSecondaryLabel: null,
			menuSecondaryIcon: null
		}
	},
	computed: {
		menu () {
			return [
				'',
				[
					{
						to: '/',
						icon: 'account',
						label: '社員管理'
					}
				],
				[
					{
						to: '/team',
						icon: 'account-multiple',
						label: 'チーム管理'
					}
				],
				[
					{
						label: 'コイン管理',
						icon: 'coin',
						menu: [
							{
								to: '/coin',
								label: 'コイン'
							},
							{
								to: '/present-list',
								label: '贈呈一覧'
							},
						]
					}
				],
				[
					{
						label: 'ニュース管理',
						icon: 'tab',
						menu: [
							{
								to: '/category',
								label: 'ニュースカテゴリ'
							},
							{
								to: '/news',
								label: '投稿一覧'
							},
						]
					}
				],
				[
					{
						label: '景品管理',
						icon: 'gift',
						menu: [
							{
								to: '/prize',
								label: '景品'
							},
							{
								to: '/prize-exchange-history',
								label: '交換履歴'
							},
						]
					},
				],
				[
					{
						to: '/information',
						icon: 'information',
						label: 'お知らせ管理'
					}
				],
				[
					{
						to: '/summary',
						icon: 'database',
						label: '集計'
					}
				],
				[
					{
						icon: 'chart-line',
						label: '帳票出力',
						menu: [
							{
								to: '/preset',
								label: 'プリセット管理'
							},
							{
								to: '/output',
								label: '集計'
							},
						]
					}
				],
				[
					{
						to: '/site-setting',
						icon: 'settings',
						label: 'サイト設定'
					}
				],
				/*
				'General',
				[
					{
						to: '/',
						icon: 'desktop-mac',
						label: 'Dashboard'
					}
				],
				'Examples',
				[
					{
						to: '/tables',
						label: 'Tables',
						icon: 'table',
						updateMark: true
					},
					{
						to: '/forms',
						label: 'Forms',
						icon: 'square-edit-outline'
					},
					{
						to: '/profile',
						label: 'Profile',
						icon: 'account-circle'
					},
					{
						label: 'Dropdown',
						icon: 'arrow-down-bold-circle',
						menu: [
							{
								href: '#void',
								label: 'Sub-item One'
							},
							{
								href: '#void',
								label: 'Sub-item Two'
							}
						]
					},
					{
						label: 'Submenus',
						icon: 'view-list',
						menuSecondaryKey: 'submenu-1',
						menuSecondaryIcon: 'view-list',
						menuSecondaryLabel: 'Example',
						menuSecondary: [
							'Something',
							[
								{
									icon: 'view-list',
									href: '#void',
									label: 'Sub-item One'
								},
								{
									icon: 'view-list',
									href: '#void',
									label: 'Sub-item Two'
								}
							],
							'Dropdown',
							[
								{
									label: 'Submenus',
									icon: 'view-list',
									menu: [
										{
											href: '#void',
											label: 'Sub-item One'
										},
										{
											href: '#void',
											label: 'Sub-item Two'
										}
									]
								}
							]
						]
					}
				],
				'Other',
				[
					{
						to: 'login',
						label: 'Login',
						icon: 'lock'
					},
					{
						to: 'error-in-card',
						label: 'Error v.1',
						icon: 'power-plug'
					},
					{
						to: 'error-simple',
						label: 'Error v.2',
						icon: 'alert-decagram'
					},
					{
						to: 'lock-screen',
						label: 'Lock Screen',
						icon: 'lock-reset'
					}
				],
				'About',
				[
					{
						href: 'https://justboil.me/bulma-admin-template/one',
						label: 'About',
						icon: 'help-circle'
					}
				]
				*/
			]
		},
		menuBottom () {
			return [
				//{
				//	action: 'logout',
				//	icon: 'logout',
				//	label: 'Log out',
				//	state: 'info'
				//}
			]
		},
		...mapState([
			'isOverlayVisible'
		])
	},
	created () {
		this.$store.commit('user', {
			name: 'John Doe',
			email: 'john@example.com',
			avatar: '/data-sources/avatars/annie-spratt-121576-unsplash.jpg'
		})

		if (this.$store.state.isAsideExpanded) {
			document.documentElement.classList.add('has-aside-expanded');
		}
	},
	methods: {
		onLogoutClick: function() {
			this.$auth.logout();
			this.$router.push({ name: 'login' });
		},
		menuClick (item) {
			if (item.menuSecondary) {
				this.menuSecondary = item.menuSecondary
				this.menuSecondaryLabel = item.menuSecondaryLabel ? item.menuSecondaryLabel : null
				this.menuSecondaryIcon = item.menuSecondaryIcon ? item.menuSecondaryIcon : null

				this.$store.commit('asideActiveForcedKeyToggle', item)
				this.$store.commit('overlayToggle', true)
			} else if (item.action && item.action === 'logout') {
				this.$buefy.toast.open({
					message: 'Log out clicked',
					type: 'is-danger',
					queue: false
				})
			}
		},
		menuSecondaryCloseClick () {
			this.$store.commit('overlayToggle', false)
		},
		menuSecondaryClose () {
			this.menuSecondary = this.menuSecondaryLabel = this.menuSecondaryIcon = null
			this.$store.commit('asideActiveForcedKeyToggle', null)
		}
	},
	watch: {
		isOverlayVisible (newValue) {
			if (!newValue) {
				this.menuSecondaryClose()
			}
		}
	}
}
</script>
